import { render, staticRenderFns } from "./MsalespeopleUpdate.vue?vue&type=template&id=dea44424&scoped=true"
import script from "./MsalespeopleUpdate.vue?vue&type=script&lang=js"
export * from "./MsalespeopleUpdate.vue?vue&type=script&lang=js"
import style0 from "./MsalespeopleUpdate.vue?vue&type=style&index=0&id=dea44424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea44424",
  null
  
)

export default component.exports